import { Bar } from '../types';

export function getChartMetadata(data: (Bar | null)[]) {
  const hasValues = data.some((d) => d !== null) && data.length > 0;
  const minYValue = Math.min(...data.map((d) => d?.value || 0));
  const maxYValue = Math.max(...data.map((d) => d?.value || 0));

  return { hasValues, minYValue, maxYValue };
}
